import { api } from "../component/constent";


// ======================================================
// SALARY MASTER
// ======================================================

export const getSalaryCodeMaster = async () => {

    const response = await api.get( "/entry/salary-code-master" );
    return response.data;
};


// ======================================================
// GET MONTH
// ======================================================

export const getEgaSectionData = async ( month,  year) => {

    const response = await api.get(
        "/entry/enga-section/month",
        {
            params: {
                month,
                year
            }
        }
    );

    return response.data;
};


// ======================================================
// SAVE
// INSERT + UPDATE
// ======================================================

export const saveEgaSectionData = async (
    payload
) => {

    const response = await api.post(
        "/entry/enga-section",
        payload
    );

    return response.data;
};


// ======================================================
// UPDATE ONE
// ======================================================

export const updateEgaSectionData = async (
    salaryCode,
    payload
) => {

    const response = await api.put(
        `/entry/enga-section/${salaryCode}`,
        payload
    );

    return response.data;
};


// ======================================================
// DELETE ONE
// ======================================================

export const deleteEgaSectionData = async (
    salaryCode,
    month,
    year
) => {

    const response = await api.delete(
        `/entry/enga-section/${salaryCode}`,
        {
            data: {
                month,
                year
            }
        }
    );

    return response.data;
};


// ======================================================
// DELETE MONTH
// ======================================================

export const deleteEgaSectionMonth = async (
    month,
    year
) => {

    const response = await api.delete(
        "/entry/enga-section/month",
        {
            data: {
                month,
                year
            }
        }
    );

    return response.data;
};